import React from 'react';
import { CardMedia, Stack, Typography } from '@mui/material';
import FocusInspectionButtonWeb from './FocusInspectionButtonWeb';

const DontSectionService = () => (
  <>
    <Stack sx={{ pb: 15, pt: 18, pr: '75px', pl: '90px', flexDirection: 'row', backgroundColor: 'white' }} gap={15}>
      <Stack width="60%">
        <CardMedia
          component="img"
          className=""
          src="assets/images/Inspection/checkpoint.webp"
          alt="Focus Inspection"
          // height={isMobile ? 25 : 40}
          sx={{ objectFit: 'contain', borderRadius: '10px' }}
        />
      </Stack>
      <Stack gap={4} width="40%" justifyContent="center">
        <Stack mt={2} gap={1}>
          <Typography color="#000000" fontSize="19px">
            ✅ Thorough inspection by{' '}
            <Typography component="span" fontSize="19px" fontWeight={700}>
              certified experts
            </Typography>
          </Typography>
          <Typography color="#000000" fontSize="19px">
            🔧 Over
            <Typography component="span" fontSize="19px" fontWeight={700}>
              130 quality checkpoints{' '}
            </Typography>
          </Typography>
          <Typography color="#000000" fontSize="19px">
            🛡️ Complete with{' '}
            <Typography component="span" fontSize="19px" fontWeight={700}>
              warranty assurance{' '}
            </Typography>
          </Typography>
        </Stack>
        <FocusInspectionButtonWeb
          title="Book a Certified Inspection!"
          subtitle="Inspection team will contact you soon."
          subTitleColor="#121212"
          onClick={() => console.log('Button clicked')}
        />{' '}
      </Stack>
    </Stack>
  </>
);

export default DontSectionService;
